(function () {
  function openMobileFacets() {
    var openTrigger = document.querySelector('.mobile-facets__open');
    var summary = document.querySelector('.mobile-facets__disclosure > summary');

    if (openTrigger) {
      openTrigger.click();
      return;
    }

    if (summary) {
      summary.click();
    }
  }

  function closeMobileFacets() {
    var disclosure = document.querySelector('.mobile-facets__disclosure');
    var summary = disclosure ? disclosure.querySelector(':scope > summary') : null;

    if (!disclosure || !disclosure.hasAttribute('open')) return;

    if (summary) {
      summary.click();
      return;
    }

    disclosure.removeAttribute('open');
    disclosure.classList.remove('menu-opening');
  }

  function bindMobileFacetButtons(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('[data-open-mobile-facets]');
    var closeButtons = root.querySelectorAll('[data-close-mobile-facets]');

    buttons.forEach(function (button) {
      if (button.dataset.mobileFacetBound === 'true') return;

      button.dataset.mobileFacetBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openMobileFacets();
      });
    });

    closeButtons.forEach(function (button) {
      if (button.dataset.mobileFacetCloseBound === 'true') return;

      button.dataset.mobileFacetCloseBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeMobileFacets();
      });
    });
  }

  function init() {
    bindMobileFacetButtons(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindMobileFacetButtons(event.target);
  });

  // Drawer content is inserted on first open (see expandMobileFacets in facets.js).
  document.addEventListener('mobile-facets:expanded', function (event) {
    (event.detail && event.detail.nodes || []).forEach(function (node) {
      bindMobileFacetButtons(node);
    });
  });
})();
